import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=07a5654c&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07a5654c')) {
      api.createRecord('07a5654c', component.options)
    } else {
      api.reload('07a5654c', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=07a5654c&", function () {
      api.rerender('07a5654c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wN9idVRvSwg0/JS/comp/ImgFallback.vue"
export default component.exports